import { combineReducers, configureStore } from "@reduxjs/toolkit";
import apiReducer from "../slices/slice";
import chatReducer from "../slices/chat.slice";
import { api } from "../api/api";
import adminReducer from "../slices/admin.slice";
import { aiReducer } from "../slices/ai.slice";

export const rootReducer = combineReducers({
  api: apiReducer,
  admin: adminReducer,
  ai: aiReducer,
  [api.reducerPath]: api.reducer,
  chat: chatReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      api.middleware,
    ]),
  devTools: process.env.NODE_ENV === "development",
  preloadedState: undefined,
});

export default store;
